import { computed } from 'mobx';
import { IEntity } from '../../main/entities';
import { IOcResponse } from '../../services/CommSvc';

export abstract class AbstractRepo<E extends IEntity> {
	constructor(public readonly id: string, private readonly listProvider: () => Array<E>) {
	}

	@computed private get map() {
		return new Map<number, E>(this.listProvider().map(e => [e.id, e]));
	}

	get length() {
		return this.map.size;
	}

	@computed get allAsList() {
		return [...this.map.values()];
	}

	// abstract etag: string

	readonly upserter = {
		create: (entity: E) => Promise.reject(),
		update: (entity: E) => Promise.reject(),
		put: (entity: E) => Promise.reject(),
		delete: (entity: E) => Promise.reject(),
	};

	clear = () => this.map.clear();

	readonly byId = (id: string | number | undefined) => id ? this.map.get(+id) : undefined;

	fetch(mode?: 'NORMAL' | 'DIRECT' | 'INVALIDATE') : Promise<unknown> {
		return Promise.reject();
	}

	fetchDirect() { //TODO remove
		return fetch('DIRECT');
	}

	abstract handleResponse(responsePromise: Promise<IOcResponse>, successMessage: string) : Promise<unknown>;
}
